var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedinLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ede9e4;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.7,0H25.3C11.3,0,0,11.3,0,25.3v93.5C0,132.7,11.3,144,25.3,144h93.5c14,0,25.3-11.3,25.3-25.3V25.3c0-14-11.3-25.3-25.3-25.3ZM43.5,123.4h-21.4V54.7h21.4v68.7ZM32.9,45.3c-6.9,0-12.4-5.5-12.4-12.4s5.5-12.4,12.4-12.4,12.4,5.5,12.4,12.4-5.6,12.4-12.4,12.4ZM123.5,123.4h-21.4v-33.4c0-8-.1-18.2-11.1-18.2s-12.8,8.7-12.8,17.6v34h-21.3V54.7h20.5v9.4h.3c2.8-5.4,9.8-11.1,20.2-11.1,21.6,0,25.6,14.2,25.6,32.7v37.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-115.4,77.3c-.6,10.5,5.2,19.4,13.2,21.8v-21.8h-13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-115.1,74.3h12.9v-18.5c-.6-.2-1.3-.3-2.1-.3-6.5.1-10.4,7.9-10.9,18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-127.5,0h-93.5c-14,0-25.3,11.3-25.3,25.3v93.5c0,14,11.3,25.3,25.3,25.3h93.5c14,0,25.3-11.3,25.3-25.3v-6.6c-.8,0-1.7.1-2.5.1-15.5,0-24.2-12.9-24.5-29,0-.6,0-1.2,0-1.9,0-.4,0-.8,0-1.1,0-.2,0-.4,0-.6,0-.2,0-.4,0-.6.6-7.1,2.8-13.4,6.6-18.1,2.3-2.9,5.2-5.1,8.4-6.6,2.8-1.4,6.8-2.2,10-2.2h.1c.6,0,1.2,0,1.8,0v-26.9c0-14-11.3-25.3-25.3-25.3ZM-128.5,34.4h-.1c-4.2,1-6.4,2.4-6.4,7.5h0v61.6c.4,4.1,2.6,5.3,6.4,6.2h.1v.9h-29.5v-.9h.1c3.8-.9,6-2.1,6.3-6.2v-60l-28.5,66.9h-1.6l-27.7-65.1v56.7c0,5.1,2.1,6.6,6.4,7.5h.1v.9h-17v-.9h.1c4.2-1,6.4-2.4,6.4-7.5v-60.2c0-5.1-2.1-6.6-6.4-7.5h-.1v-.9h25l21.5,50.6,21.5-50.6h23.2v.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-470 65.4 -470 78.5 -460.3 71.9 -470 65.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-466.2 87.5 -433.4 109.2 -433.4 89.7 -451.6 77.7 -466.2 87.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-391.1 56.4 -423.8 34.7 -423.8 53.8 -405.6 66.1 -391.1 56.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-428.6 62.2 -442.9 71.8 -428.6 81.3 -414.3 71.8 -428.6 62.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-433.4 53.8 -433.4 34.7 -466.1 56.4 -451.6 66.1 -433.4 53.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-381.9,0h-93.5c-14,0-25.3,11.3-25.3,25.3v93.5c0,14,11.3,25.3,25.3,25.3h93.5c14,0,25.3-11.3,25.3-25.3V25.3c0-14-11.3-25.3-25.3-25.3ZM-377.5,87.5c0,.9-.2,1.8-.8,2.7,0,0-.1.2-.2.2-.4.5-.8.9-1.3,1.3l-46.1,30.6c-.8.5-1.7.8-2.7.8h0c-1,0-1.9-.3-2.7-.8l-46.1-30.6c-.5-.3-1-.7-1.3-1.3,0,0-.1-.2-.2-.2-.5-.8-.8-1.7-.8-2.7v-31c0-.9.2-1.8.8-2.7,0,0,0-.1.1-.2.4-.5.8-1,1.4-1.3l46.1-30.6c1.6-1.1,3.9-1.1,5.5,0l46.1,30.6c.5.3,1,.8,1.4,1.3,0,0,0,.1.1.2.5.8.8,1.8.8,2.7v31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-423.8 89.7 -423.8 109.2 -391.1 87.5 -405.7 77.7 -423.8 89.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-387.2 78.5 -387.2 65.4 -396.9 71.9 -387.2 78.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinLight);
export default __webpack_public_path__ + "static/media/icon-linkedin-light.35f752ee7b0c654c78a9f7b7ddad17ca.svg";
export { ForwardRef as ReactComponent };